export default {
    type: 'programmes',
    name: 'Programmes',
    osOnly: true,
    components: {
        root: {
            name: 'ModuleProgrammes',
            loader: () => import('./ModuleProgrammes')
        }
    }
};
